// Centralized error handling utility
import { toast } from "react-toastify"

export const handleApiError = (error, customMessage = null) => {
   if (error.response?.data?.status?.description) {
      toast.error(error.response.data.status.description)
   } else if (error.message) {
      toast.error(error.message)
   } else if (customMessage) {
      toast.error(customMessage)
   } else {
      toast.error("An unexpected error occurred")
   }
}

export const handleApiErrorWithLogs = (error, setLogs, logMessage = "Check error on logs") => {
   if (error.response?.data?.status?.description) {
      const data = error.response.data.status.description.split(",")
      setLogs(data)
      toast.error(logMessage)
   } else {
      handleApiError(error)
   }
}
